<template>
  <v-container>
    <v-row>
      <span>Текст * (<TranslationIcon />)</span>
      <QuillEditorVue
        :cols="12"
        :content="listItem.data.text"
        :loading="isLoading"
        :disabled="isLoading"
        :isShowErrorMessage="true"
        :errorText="errorMessages.text"
        light-mode
        :title="''"
        @input="mixChangeListItemHandler($event, 'text')"
        @onChangeContent="mixChangeListItemHandler($event, 'descriptionForMobile')"
      />
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import QuillEditorVue from '@/components/quill-editor'

export default {
  name: 'TextWidget',
  components: { TranslationIcon, QuillEditorVue },
  mixins: [dynamicListItemMix]
}
</script>
